module.exports = __webpack_public_path__ + "img/one-way-flight.6becc5de.svg";